import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "zyxel",
  "use": "zyxel-usage",
  "viewBox": "0 0 110.986 110.986",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 110.986 110.986\" id=\"zyxel\"><path d=\"M87.053 88.037H44.83l23.645-32.17 25.502-34.7c2.986-4.067 2.115-9.794-1.953-12.785a9.1 9.1 0 0 0-5.02-1.745H27.192a8.525 8.525 0 0 0-8.525 8.525c0 4.71 3.82 8.53 8.525 8.53h42.224L45.77 55.867 20.267 90.563c-2.99 4.066-2.116 9.796 1.95 12.788 1.522 1.112 3.27 1.664 5.02 1.746h59.815c4.708 0 8.53-3.82 8.53-8.527 0-4.71-3.822-8.533-8.53-8.533\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol